<template>
  <section class="section is-small">
    <div class="container">
      <div class="notification is-dvodark">
          <div class="columns is-centered">
              <div class="column is-one-fifth is-offset-two-fifths has-text-centered">
                  <h1 class="is-size-3">
                      WARRANTY CREDIT REQUESTS
                  </h1>
              </div>
              <div class="column is-one-fifth is-offset-one-fifth">
            <b-button tag="router-link"
                to="/warranty-request"
                type="is-dvogreen">
                Create New Request
            </b-button>              
            </div>
          </div>
          <section>
          <b-table :data="warranties" paginated :per-page="10" :current-page.sync="currentPage"
              :pagination-simple="false" pagination-position="bottom" striped :loading="isLoading">
              <b-table-column field="submitted" label="Date Submitted"  sortable width="40" v-slot="props">
                  <span v-if="props.row.submitted" class="tag is-warning">
                        {{ new Date(props.row.submitted).toLocaleDateString() }}
                  </span>
              </b-table-column>
              <b-table-column field="id" label="Warranty ID" width="40" searchable v-slot="props">
                <router-link v-if="isAdmin" :to="{ name: 'WarrantyApproval', params: { id: props.row.id }  }">
                    {{ props.row.id }}
                </router-link>
                <p v-else>
                    {{props.row.id}}
                </p>
              </b-table-column>
              <b-table-column field="reference_number" label="Reference #" searchable width="40" v-slot="props">
                  {{ props.row.reference_number }}
              </b-table-column>
              <b-table-column field="serial_id" label="Item To Repair" searchable width="40" v-slot="props">
                  {{ props.row.serial_id }}
              </b-table-column>
              <b-table-column field="total" label="Total" width="40" v-slot="props" sortable>
                {{props.row.total}}
              </b-table-column>
              <b-table-column field="approved" label="Approval" width="40" searchable>
                <template slot="searchable" slot-scope="props" >
                  <b-select placeholder="All" v-model="props.filters[props.column.field]" >
                      <option value="">All</option>
                      <option value="Pending">Pending</option>
                      <option value="Approved">Approved</option>
                      <option value="Cancelled">Cancelled</option>
                  </b-select>
                </template>
                <template v-slot="props">{{props.row.approved}}</template>
              </b-table-column>
            <template #empty>
                <div class="has-text-centered">No records</div>
            </template>
          </b-table>
          </section>
      </div>
    </div>
  </section>
</template>

<script>
import { API } from 'aws-amplify';
import { warrantyReader} from '../graphql/queries'
import { mapState } from "vuex";

export default {
  data(){
    return{
      currentPage: 1,
      warranties: [],
      isLoading: false 
    }
  },
  methods: {
    async getWarranties(){
    this.isLoading = true;
    try {
      
          const Warranties = await API.graphql({
              query: warrantyReader,
                  variables: {
                      input: {
                        request_type: 'read_all'
                      }
                  }
      });
    this.warranties = Warranties.data.warrantyReader
    } catch (e) {
          this.$buefy.notification.open({
          duration: 5000,
          message: `${e}`,
          position: 'is-bottom',
          type: 'is-danger',
          hasIcon: true
      })
    }
    this.isLoading = false
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      isAuthenticated: state => state.auth.isAuthenticated,
      isAdmin: state => state.auth.isAdmin
    })
  },
  mounted(){
    this.getWarranties();
  }
}
</script>

<style>

th{
  font-size: 1em;
  font-family: 'Roboto', sans-serif;
  font-weight: 900; 

}
.is-green-border{
  border: 1px solid #82bc00;
}

.field-label .label {
    color: #82bc00 !important;
    font-size: 0.8em;
    font-family: 'Roboto', sans-serif;
    font-weight: 100;
}

input[type="text"], textarea {
  background-color : transparent; 
  color: white;
}

.textarea {
  background-color : transparent; 
  color: white;
}

.select{
  background-color : transparent; 
  color: white;
}

h1 {
  font-family: 'Anton', sans-serif;
}

p {
  font-family: 'Roboto', sans-serif;
  font-weight: 100;
}
</style>